import React from 'react';
import { FaWhatsapp } from 'react-icons/fa'; // Import WhatsApp icon

const WhatsAppChat = () => {
  const phoneNumber = "447920810633"; // Replace with your WhatsApp number
  const message = "Hello, I have a question about your service.";

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div>
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '20px', // Distance from the bottom
          right: '20px', // Distance from the right
          width: '55px',
          height: '55px',
          backgroundColor: '#25D366', // WhatsApp green
          color: 'white',
          borderRadius: '50%', // Circular shape
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', // Soft shadow
          transition: 'all 0.3s ease-in-out', // Smooth transition
          zIndex: 1000, // Ensure it's above other elements
        }}
        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
      >
        <FaWhatsapp size={30} />
      </a>
    </div>
  );
};

export default WhatsAppChat;
